import { render } from "./HrTransfers.vue?vue&type=template&id=6d45f7e7&scoped=true"
import script from "./HrTransfers.vue?vue&type=script&lang=js"
export * from "./HrTransfers.vue?vue&type=script&lang=js"

import "./HrTransfers.vue?vue&type=style&index=0&id=6d45f7e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d45f7e7"]])

export default __exports__